import React from 'react';
import { Form } from 'react-form';

import Popup from '../../Popup';
import { Select } from '../../Form';
// import { required } from '../../../utils/validation';

const SingleSelectPopup = props => {
    const { onCloseClick, onSubmit, defaultValues = { [props.fieldName]: '' }, options, fieldName, submitLabel, emptyOption, hiddenDefault, 'data-testid': dataTestId } = props;

    return (
        <Popup
            className={`popup-md clear-over-flow`}
            popUpContentWrapperClassName={`pl16 pr16 pb8`}
            onCloseClick={onCloseClick}
            config={{
                noPadding: true,
                fullScreen: false,
                topGradient: false,
                scrollable: false,
            }}
            data-testid={dataTestId}
        >
            <div className={`mb24`}>
                <h4 data-testid={dataTestId && `${dataTestId}.title`}>Tag Player as...</h4>
            </div>
            <div className={`mb16`}>
                <Form onSubmit={values => onSubmit(values)} defaultValues={defaultValues}>
                    {(formApi) => {
                        const { submitForm } = formApi;
                        return (
                            <form onSubmit={submitForm} className="mb0">
                                <div className="row">
                                    <div className={`col-12`}>
                                        <Select
                                            key={`event-format-type`}
                                            id={`event-format-type`}
                                            field={fieldName}
                                            value={defaultValues[fieldName]}
                                            hiddenDefault={hiddenDefault}
                                            options={options}
                                            // validate={required}
                                            emptyOption={emptyOption}
                                            data-testid={dataTestId && `${dataTestId}.select`}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <button
                                            onClick={onCloseClick}
                                            type="button"
                                            className="btn btn-default btn-xl text-uppercase btn-block"
                                            data-testid={dataTestId && `${dataTestId}.cancel-btn`}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <button
                                            type="submit"
                                            className="btn btn-primary btn-xl text-uppercase btn-block"
                                            data-testid={dataTestId && `${dataTestId}.submit-btn`}
                                        >
                                            {submitLabel || 'OK'}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        );
                    }}
                </Form>
            </div>
        </Popup>
    );
};

SingleSelectPopup.propTypes = {

};

export default SingleSelectPopup;
